/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-05-26 17:04:41
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-06-08 16:38:29
 * @FilePath: \crm-product\src\views\performanceCalculation\views\import_statement\product_price\form\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Form, {
  formCreate,
} from '@/found/components/form';
import request from '@/found/utils/request';
import peopleList from '../../product_price/form/product_list.vue';

formCreate.component('peopleList', peopleList);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {

    };
  },
  async created() {
    await this.getFormRule('main-form');
  },
  methods: {
    // 设置规则
    setRule(item) {
      const v = item;
      if (v.field === 'userName' || v.field === 'superiorName') {
        v.props = {
          ...v.props,
          params: {
            functionCode: 'choose-people-list',
            parentCode: 'CRM20260605000000003',
            paramData: {
              enableStatus: '009',
            },
          },
          title: '选择人员',
        };
        v.on = {
          ...v.on,
          change: (e) => {
            if (e && e.length) {
              const objProduct = e[0];
              const userCode = this.getRule('userCode');
              const superiorCode = this.getRule('superiorCode');
              if (v.field === 'userName') {
                if (superiorCode.value && superiorCode.value === objProduct.userName) {
                  this.$message.error('上级不能与人员相同!');
                  return false;
                }
                this.setValue({
                  userName: objProduct.fullName,
                  userCode: objProduct.userName,
                  orgCode: objProduct.orgCode,
                  orgName: objProduct.orgName,
                  userRole: objProduct.positionLevelName,
                });
              } else if (v.field === 'superiorName') {
                if (userCode.value && userCode.value === objProduct.userName) {
                  this.$message.error('人员不能与上级相同!');
                  return false;
                }
                this.setValue({
                  superiorName: objProduct.fullName,
                  superiorCode: objProduct.userName,
                  superiorOrgCode: objProduct.orgCode,
                  superiorOrgName: objProduct.orgName,
                  superiorRole: objProduct.positionLevelName,
                });
              }
            }
          },
        };
      }
      if (v.field === 'promotionOrgCode') {
        v.on = {
          ...v.on,
          getItem: (e) => {
            this.setValue({
              promotionOrgName: e.dictValue,
            });
          },
        };
      }
      return v;
    },
    // 渲染完成后执行
    formComplete() {
      const {
        code,
      } = this.formConfig;
      if (code === 'view' || code === 'edit') {
        request.post('/mdm/performanceuserinfo/query', {
          id: this.formConfig.row.id,
        }).then((res) => {
          if (res.success) {
            const {
              result,
            } = res;
            this.setValue({
              ...result,
              statMonth: `${result.statMonth}`,
            });
          }
        });
      }
    },
    submit() {
      const formData = this.getFormData(); // 获取表单的值
      if (formData) {
        let url = '/mdm/performanceuserinfo/save';
        const params = {
          ...formData,
          statMonth: Number(formData.statMonth),
        };
        if (this.formConfig.code === 'edit') {
          url = '/mdm/performanceuserinfo/update';
          params.id = this.formConfig.row.id;
        }
        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
